var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-block px-2 py-1 font-medium rounded-full",class:[
    _vm.textClass,
    { ' bg-gray-100 text-gray-800': _vm.type === '' || _vm.type === ' GRAY'},
    { ' bg-blue-100 text-blue-800': _vm.type === 'BLUE'},
    { ' bg-yellow-100 text-yellow-800': _vm.type === 'YELLOW'},
    { ' bg-green-100 text-green-800': _vm.type === 'GREEN'},
    { ' bg-red-100 text-red-800': _vm.type === 'RED'} ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }